var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightWhite2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8281)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8281",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0235 24.9991C49.0323 28.1554 48.4148 31.282 47.2068 34.198C45.9988 37.1139 44.2243 39.7612 41.9861 41.9866C39.7609 44.2244 37.1139 45.9986 34.1984 47.2065C31.2829 48.4144 28.1567 49.0319 25.0009 49.0233C21.8447 49.0319 18.7182 48.4144 15.8023 47.2066C12.8864 45.9988 10.239 44.2245 8.01336 41.9867C5.7755 39.7611 4.0013 37.1137 2.79345 34.1978C1.58559 31.2818 0.968081 28.1553 0.976651 24.9991C0.968079 21.8433 1.58558 18.7171 2.79342 15.8016C4.00127 12.886 5.77546 10.239 8.01327 8.01378C10.2387 5.77557 12.886 4.0011 15.802 2.79313C18.718 1.58516 21.8446 0.967678 25.0009 0.976475C28.1568 0.967636 31.2831 1.5851 34.1988 2.7931C37.1144 4.00111 39.7613 5.77563 41.9862 8.01387C44.2244 10.2388 45.9988 12.8858 47.2068 15.8014C48.4148 18.7169 49.0323 21.8432 49.0235 24.9991ZM22.4825 36.3313L25.0009 38.8508L38.852 24.9988L25.0009 11.1484L22.4825 13.668L32.0155 23.201L11.1489 23.201V26.7984L32.0155 26.7984L22.4825 36.3315V36.3313Z",
    fill: "#F9F9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWhite2);
export default __webpack_public_path__ + "static/media/arrow_right_white – 2.826604604a6f7fd3f20c030d91b2e2fb.svg";
export { ForwardRef as ReactComponent };